/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NextControl/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function NextControl({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/NextControl"
  
}) {
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let eventAppointmentIntervalToNextValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.interval_to_next',
})
let eventAppointmentValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment',
})
let eventsValueData = fromData.useDataValue({ viewPath,
context: 'events',
})
let aggregateData = fromHelpers.isDisabled(eventAppointmentValueData, eventsValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onChange = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let onBlur = fromHelpers.useOnSave({
  children,
  viewPath
  
})
let onSubmit = fromHelpers.useOnSave({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 data="options"
 from={optionsValueData}
 data="event.appointment.interval_to_next"
 value={eventAppointmentIntervalToNextValueData}
 data="event.appointment"
 data="events"
 aggregate="helpers.js isDisabled"
 disabled={aggregateData}
 onChange={onChange}
 onBlur={onBlur}
 onSubmit={onSubmit}
 size="small"
 clearFilterOnBlur={true}
 marginTop={0}
 marginBottom={0}
 marginLeft={dtSpaceXxs}
 flexDirection="row"
 alignItems="center"
 flexBasis={0}
 flexGrow={0}
 flexShrink={0}
 height="100%"
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 marginRight={dtSpaceXxs}
 marginBottom={0}
 text="Next visit"
/>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
 width={80}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}